import { useSelector } from 'react-redux'
import useUserHdPackageActions from 'user-module/hd-package/core/useUserHdPackageActions'
import useReload from 'shared-module/loading/useReload'
import useLoad from 'shared-module/loading/useLoad'

export const useUserHdPackage = () => useSelector(state => state.galleryPhoto.fullHdPackage)
export const useReloadUserHdPackage = () => useReload(useUserHdPackage(), useUserHdPackageActions().get)
export const useLoadUserHdPackage = () => useLoad('user-hd-package', useUserHdPackage(), useUserHdPackageActions().get)
